export const menus = () => {
	// Add event listeners to allergen filter inputs
	const allergenInputs = document.querySelectorAll('.menu__alergens-filter-item input');
	
	allergenInputs.forEach(input => {
		input.addEventListener('change', checkForEmptyResults);
	});

	function checkForEmptyResults() {
		const menuSubcats = document.querySelectorAll('.menu-subcat');
		const allHidden = Array.from(menuSubcats).every(subcat => 
			subcat.classList.contains('hidden')
		);

		// Get or create the message element
		let messageEl = document.querySelector('.no-results-message');
		if (!messageEl) {
			messageEl = document.createElement('p');
			messageEl.className = 'no-results-message';
			messageEl.textContent = 'No items found for the selected filter, please amend your filter to view menu items.';
			// Insert after the last menu-subcat element
			menuSubcats[menuSubcats.length - 1].after(messageEl);
		}

		// Show/hide the message based on results
		messageEl.style.display = allHidden ? 'block' : 'none';
	}
}